import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const Card = ({
  gridConfig,
  card,
  index,
  visibleCategories,
  onHoverGroup,
  introAnimationComplete,
  filter,
}) => {
  const cardRef = useRef(null);
  const [{ posX, posY }, setPositions] = useState({ posX: null, posY: null });
  const [{ x, y, w, h }, setSavePositions] = useState({
    x: 0,
    y: 0,
    w: 0,
    h: 0,
  });
  const pointerEvents = useRef(false);

  useEffect(() => {
    init(index);
  }, [gridConfig, filter]);

  useEffect(() => {
    if (introAnimationComplete) pointerEvents.current = true;
  }, [introAnimationComplete]);

  const init = (index) => {
    const row = Math.ceil(index / gridConfig.columns) - 1;
    const column = index - gridConfig.columns * row - 1;
    updatePosition(column, row);
  };

  const updatePosition = (column, row) => {
    const posX = column * gridConfig.cardWidth;
    const posY = row * gridConfig.cardHeight;
    addHole(column, row, posX, posY);
  };

  const addHole = (column, row, posX, posY) => {
    let newPosY = posY;
    //hole:
    const holeSpan = gridConfig.hole.length;
    if (holeSpan > 0) {
      const begin = gridConfig.columns / 2 - holeSpan / 2;
      gridConfig.hole.forEach((hole, i) => {
        if (column == begin + i) {
          if (row < Math.floor(gridConfig.rows / 2)) {
            //is in upper half
            newPosY = posY - gridConfig.cardHeight * (hole / 2);
          } else {
            //is in lower half
            newPosY = posY + gridConfig.cardHeight * (hole / 2);
          }
        }
      });
    }

    // Add offset based on column offset
    if (column % 2 == 0) {
      //offset even columns
      newPosY = newPosY + gridConfig.cardHeight * gridConfig.offsetCol.even;
    } else {
      // offset uneven columns
      newPosY = newPosY + gridConfig.cardHeight * gridConfig.offsetCol.uneven;
    }

    setPositions((prevState) => ({
      ...prevState,
      posX: posX,
      posY: newPosY,
    }));
  };

  const savePositions = () => {
    const target = cardRef.current.querySelector(".gridCard");
    const boundingRect = target.getBoundingClientRect();
    setSavePositions({
      x: boundingRect.left,
      y: boundingRect.top,
      w: target.offsetWidth,
      h: target.offsetHeight,
    });
  };

  return (
    <Link
			ref={cardRef}
			className="gridCell"
      onMouseDown={introAnimationComplete ? () => savePositions() : null}
      to={{
        pathname: `/${card.meta.slug}`,
        state: {
          card: { savePosition: { x: x, y: y, w: w, h: h } },
        },
      }}
			style={{
				width: '100%',
				height: '100%'
			}}
      style={{
        display: "block",
        transform: `translateX(${posX}px) translateY(${posY}px) translateZ(0)`,
        width: `${gridConfig.cardWidth}px`,
        height: `${gridConfig.cardHeight}px`,
        opacity: `${
					visibleCategories.includes(card.meta.category) ||
					introAnimationComplete
						? 1
						: 0
				}`,
				transition: "all 0.3s ease",
				transitionDelay: introAnimationComplete ? `${Math.random() * 0.2}s` : `${Math.random() * 1.05}s`,
        pointerEvents: pointerEvents.current ? "auto" : "none",
      }}
    >
      <div
        className={`gridCard gridCard--${card.meta.category}`}
        onMouseEnter={() => onHoverGroup(card.meta.category, "enter")}
        onMouseLeave={() => onHoverGroup(card.meta.category, "leave")}
      >
        <img
          className="gridCardImage"
          src={`assets/cover/${card.meta.slug}.jpg`}
					alt={card.meta.cover.alt}
        />
        <div className="gridCardExcerpt">
          <div className="gridCardTag">#{card.meta.name}</div>
          {card.meta.excerpt && (
            <p className="gridCardText">
              {card.meta.excerpt.before.length >= 60
                ? `${card.meta.excerpt.before.substring(0, 70)}...`
                : card.meta.excerpt.before}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};
